import { HTTP } from "../../services/api-service.js";
import commonObj from "../../services/common.js";
var common = new commonObj();
var baseUrl = common.baseURL;

const purchaseOrdersStore = {
  namespaced: true,
  actions: {
    getPurchaseOrderDetails({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/PO/GetPO", { poNum: param.poNum })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getPOList({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/PO/getPOHdrList", {
          entNum: "",
          txNum: "",
          sWhere: ""
        })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getPOEnquiryList({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/PO/GetPOList", param)
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getPOSchedule({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/PO/POScheduleWthStkBal", param)
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    savePurchaseOrder({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/PO/SavePO", JSON.stringify({ po: param.POModel }))
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    deletePO({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/PO/DeletePO", { poNum: param.poNum })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    //取消采购订单
    ClosePO({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/po/ClosePO", { poNums: param.poNums })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    submitPO({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/PO/SubmitPO", { poNum: param.poNum })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    postPO({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/PO/PostPO", { poNum: param.poNum })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    approvePO({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/PO/ApprovePO", { poNumber: param.poNum })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    rejectPO({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/PO/RejectPO", { poNumber: param.poNum })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    exportFile({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/mm/export", state.q, { responseType: "blob" })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getPurchasePivotList({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/gr/PurchasePivotList")
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getPurchaseReturnList({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/pr/getprlist", param)
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    savePurchaseReturn({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/pr/SavePurchaseReturn",
          JSON.stringify({
            header: param.header,
            details: param.details,
            misc: param.misc
          })
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getPRByTxNum({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/pr/GetPRByTxNum", { txNum: param.txNum })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    deletePR({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/pr/delete", { txNum: param.txNum })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    poRpt({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/po/porpt")
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    printPO({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/PO/Print",
          { txNum: param.txNum, rptID: param.rptID },
          { responseType: "blob" }
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    }
  }
};
export default purchaseOrdersStore;
